// ─────────────────────────────────────────────────────────────
// EDITABLE GALLERY DATA
// Licensed stock placeholders. Replace `src` values with real
// salon photography when provided — keep the same structure.
// Categories: Salon | Hair | Styling | Beauty | Interior
// ─────────────────────────────────────────────────────────────

const img = (id, w = 1000) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const galleryFilters = [
  "All",
  "Salon",
  "Hair",
  "Styling",
  "Beauty",
  "Interior",
];

export const galleryImages = [
  {
    id: "g1",
    src: img("1560066984-138dadb4c035"),
    category: "Salon",
    alt: "Styling stations and mirrors inside a modern salon",
    ratio: "landscape",
  },
  {
    id: "g2",
    src: img("1492106087820-71f1a00d2b11"),
    category: "Hair",
    alt: "Finished colour with soft flowing waves",
    ratio: "portrait",
  },
  {
    id: "g3",
    src: img("1585747860715-2ba37e788b70"),
    category: "Interior",
    alt: "Warm salon interior with classic barber chairs",
    ratio: "landscape",
  },
  {
    id: "g4",
    src: img("1487412947147-5cebf100ffc2"),
    category: "Beauty",
    alt: "Professional beauty and makeup application",
    ratio: "portrait",
  },
  {
    id: "g5",
    src: img("1522337094846-8a818192de1f"),
    category: "Styling",
    alt: "Hair set in curlers during a relaxed styling session",
    ratio: "portrait",
  },
  {
    id: "g6",
    src: img("1519699047748-de8e457a634e"),
    category: "Hair",
    alt: "Natural textured hair styled with volume",
    ratio: "portrait",
  },
  {
    id: "g7",
    src: img("1633681926022-84c23e8cb2d6"),
    category: "Salon",
    alt: "Contemporary salon floor with mirrors and greenery",
    ratio: "landscape",
  },
  {
    id: "g8",
    src: img("1512690459411-b9245aed614b"),
    category: "Interior",
    alt: "Leather salon chair and warm interior details",
    ratio: "landscape",
  },
  {
    id: "g9",
    src: img("1605497788044-5a32c7078486"),
    category: "Styling",
    alt: "Stylist blow-drying a client's hair",
    ratio: "portrait",
  },
  {
    id: "g10",
    src: img("1521590832167-7bcbfaa6381f"),
    category: "Interior",
    alt: "Salon styling chairs and mirror wall",
    ratio: "landscape",
  },
  {
    id: "g11",
    src: img("1519415510236-718bdfcd89c8"),
    category: "Beauty",
    alt: "Calm spa ritual with warm water and florals",
    ratio: "portrait",
  },
  {
    id: "g12",
    src: img("1562322140-8baeececf3df"),
    category: "Hair",
    alt: "Stylist finishing a blow-dry in the salon",
    ratio: "portrait",
  },
  {
    id: "g13",
    src: img("1522337660859-02fbefca4702"),
    category: "Beauty",
    alt: "Detailed nail care and polish",
    ratio: "portrait",
  },
  {
    id: "g14",
    src: img("1622287162716-f311baa1a2b8"),
    category: "Styling",
    alt: "Precision haircut in progress",
    ratio: "landscape",
  },
];
